import {
	createORPCClient,
	type InferClientInputs,
	type InferClientOutputs,
	isDefinedError,
} from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type {
	ErrorFromErrorMap,
	InferContractRouterErrorMap,
} from "@orpc/contract";
import type { RouterClient } from "@orpc/server";
import { createRouterClient } from "@orpc/server";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

import router from "@/orpc/router";

const getORPCClient = createIsomorphicFn()
	.server(() =>
		createRouterClient(router, {
			context: () => ({
				headers: getRequestHeaders(),
			}),
			interceptors: [
				async (options) => {
					const response = await options.next();

					return response;
				},
			],
		}),
	)
	.client((): RouterClient<typeof router> => {
		const link = new RPCLink({
			url: `${window.location.origin}/api/rpc`,
			interceptors: [
				async (options) => {
					const response = await options.next();

					return response;
				},
			],
		});

		return createORPCClient(link);
	});

export const client: RouterClient<typeof router> = getORPCClient();

export const orpc = createTanstackQueryUtils(client);

export type Inputs = InferClientInputs<typeof client>;
export type Outputs = InferClientOutputs<typeof client>;

export function validationErrors(e: unknown) {
	const error = e as ErrorFromErrorMap<
		InferContractRouterErrorMap<typeof router>
	>;

	if (isDefinedError(error)) {
		if (error.code === "INPUT_VALIDATION_FAILED") {
			return {
				fields: error.data.fieldErrors,
				form:
					error.data.formErrors.length > 0
						? error.data.formErrors
						: ["Please verify the form and try again."],
			};
		}
		if (error.message) {
			return { form: error.message };
		}
	}
}
